import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { checkSession } from "../store/Authentication/AuthSlice";

/**
 * Previously this decided "logged in" by whether `localStorage.accessToken`
 * existed — a value any script (or a person in devtools) can fake without a
 * real session behind it. It now asks the server (GET /auth/session, behind
 * the hardened session-validating middleware) before rendering anything,
 * and re-checks on every mount rather than only at login time
 * (Task #100).
 */
const ProtectedRoute = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [status, setStatus] = useState("checking"); // "checking" | "authorized" | "denied"

  useEffect(() => {
    let cancelled = false;
    dispatch(checkSession())
      .then((res) => {
        if (cancelled) return;
        const ok = res?.payload?.status === 200 || res?.payload?.data?.statusCode === 200;
        if (ok) {
          setStatus("authorized");
        } else {
          setStatus("denied");
          navigate("/auth/login");
        }
      })
      .catch(() => {
        if (cancelled) return;
        setStatus("denied");
        navigate("/auth/login");
      });
    return () => {
      cancelled = true;
    };
    // Intentionally re-runs on every mount of a protected route, not just
    // once globally — each protected page load re-confirms server-side
    // session validity rather than trusting a previous in-memory result.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (status !== "authorized") return null;
  return <>{props.children}</>;
};

export default ProtectedRoute;
